import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["name", "disabled"]

import {VJoyLabel, VJoyFormError} from '@maltjoy/core-vue';
    import {computed} from 'vue';
    import InputOtp from 'primevue/inputotp';

    interface Props {
        label?: string;
        length?: number;
        errorMessage?: string;
        disabled?: boolean;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MaltOtpInput',
  props: /*@__PURE__*/_mergeModels({
    label: {},
    length: { default: 6 },
    errorMessage: {},
    disabled: { type: Boolean, default: false }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

    const props = __props;

    const modelValue = _useModel<string>(__props, "modelValue");

    const hasErrorMessage = computed(() => Boolean(props.errorMessage));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.label)
      ? (_openBlock(), _createBlock(_unref(VJoyLabel), { key: 0 }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(InputOtp), {
      modelValue: modelValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
      length: _ctx.length,
      invalid: hasErrorMessage.value,
      disabled: _ctx.disabled,
      "integer-only": ""
    }, {
      default: _withCtx(({attrs, events, index}) => [
        _createElementVNode("input", _mergeProps(attrs, _toHandlers(events, true), {
          type: "numeric",
          name: `otp-input-${index}`,
          disabled: _ctx.disabled,
          class: [{'otp-input__invalid': hasErrorMessage.value}, "otp-input"]
        }), null, 16, _hoisted_1)
      ]),
      _: 1
    }, 8, ["modelValue", "length", "invalid", "disabled"]),
    (hasErrorMessage.value)
      ? (_openBlock(), _createBlock(_unref(VJoyFormError), { key: 1 }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})